import { createAsyncThunk } from '@reduxjs/toolkit'
import ACTIONS from '../constants'
import { AppState } from '../store'
import { ptAPI } from '../../shared/api/PTAPI'

export const setPtRuns = createAsyncThunk<any, void, { state: AppState }>(
  ACTIONS.PT.SET_PT_RUNS,
  async (_, { getState }) => {
    const {
      currentUser: { token },
    } = getState()
    if (token) {
      return await ptAPI.getPtRuns()
    }
    return null
  },
)

export const setPtKPIsForCurrentRun = createAsyncThunk<any, { runId: number }, { state: AppState }>(
  ACTIONS.PT.SET_PT_KPIS_FOR_CURRENT_RUN,
  async ({ runId }, { getState }) => {
    const {
      currentUser: { token },
    } = getState()
    if (token) {
      const results = await ptAPI.getPtKPIsForCurrentRun(runId)
      return {
        runId,
        results,
      }
    }
    return null
  },
)

